/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box, IconButton, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { Autocomplete } from '@mui/material';
import CreatePDF from './CreatePdf';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import PropTypes, { func } from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useTheme } from '@mui/material/styles'
import services from '../Service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import Chip from '@material-ui/core/Chip';

var screenCode = "FINANCIALGRNREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default function FinancialGRNReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("0");
    const [selectedSupplierType, setSelectedSupplierType] = useState("0");  
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Financial GRN Report'
    });
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('FarmerName');
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [farmerList, setFarmerList] = useState([]);
    const [grnDetails, setGRNDetails] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [selectedOptionsFCC, setSelectedOptionsFCC] = useState([]);
    const [selectedOptionsFarmer, setSelectedOptionsFarmer] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        farmerID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });
    const [totalValues, setTotalValues] = useState({
        totalPurchaceValue: 0,
        totalDeduction: 0,
        totalNetPurchaseValue: 0,

    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptionsFCC,
            farmerID: selectedOptionsFarmer,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },

        validationSchema: () => {
            return Yup.object().shape({
                groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
                operationEntityID: Yup.array()
                    .min(1, 'Please select at least one Fresh collection center')
                    .required('Please select at least one Fresh collection center'),
                farmerID: Yup.array()
                    .min(1, 'Please select at least one Farmer')
                    .required('Please select at least one Farmer'),
                toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
                fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
            });
        },

        onSubmit: (values) => {
            trackPromise(SubmitForm());
        }
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };
    async function SubmitForm() {
        setPage(0);
        let model = {
            FarmerID: selectedOptionsFarmer.map(x => x).join(',').toString(),
            GroupID: parseInt(formik.values.groupID),
            OperationEntityID: selectedOptionsFCC.map(x => x).join(',').toString(),
            InvoiceType: selectedInvoiceType,
            StartDate: new Date(fromDate),
            EndDate: new Date(toDate)
        }
        let newRes = await services.GetFinancialGRNDetailsByFarmerID(model);
        setGRNDetails(newRes);
        createDataForExcel(newRes);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getPermissions());
        setPage(0);
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        if (selectedOptionsFCC.length > 0) {
            trackPromise(GetFarmerDetailsByMultipleFactoryID());
        }
    }, [formik.values.operationEntityID, selectedOptionsFCC,selectedSupplierType]);

    useEffect(() => {
        clear();
        setSelectedInvoiceType("0");
        setSelectedSupplierType("0")
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setGRNDetails([]);
    }, [formik.values.farmerID, operationEntityList]);

    useEffect(() => {
        setGRNDetails([]);
    }, [toDate]);

    useEffect(() => {
        setGRNDetails([]);
    }, [fromDate]);

    useEffect(() => {
        if (selectedSupplierType === "1") {
            setSelectedInvoiceType("2");
        }
       else {
        setSelectedInvoiceType("0");
       }
    }, [selectedSupplierType]);

    useEffect(() => {
        setGRNDetails([]);
    }, [selectedInvoiceType,selectedSupplierType]);

    useEffect(() => {
        setGRNDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
    }, [formik.values.farmerID, operationEntityList,selectedOptionsFCC,selectedOptionsFarmer,formik.values.operationEntityID,selectedSupplierType]);

    useEffect(() => {
        setSelectedOptionsFCC(operationEntityList.map(option => option.value));
    }, [operationEntityList]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptionsFCC(selectedOptions)
    }, [operationEntityList]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptionsFCC,
            farmerID: selectedOptionsFarmer
        })
    }, [selectedOptionsFCC, selectedOptionsFarmer]);

    useEffect(() => {
        if (grnDetails.length != 0) {
            calculateTotalQty()
        }
    }, [grnDetails]);


    useEffect(() => {
        setPage(0);
        setSelectedOptionsFarmer([])
    }, [formik.values.operationEntityID,selectedSupplierType]);

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptionsFCC(
                selectedOptionsFCC.length === operationEntityList.length ? [] : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptionsFCC(selectedValues);
        }
        setGRNDetails([]);
    };

    const handleSelectChangeFarmer = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptionsFarmer(
                selectedOptionsFarmer.length === farmerList.length
                    ? []
                    : farmerList.map((option) => option.value)
            );
        } else {
            setSelectedOptionsFarmer(selectedValues);
        }
        setGRNDetails([]);
    };

    const handleClearSelection = () => {
        setSelectedOptionsFCC([]);
        setSelectedOptionsFarmer([]);
        setGRNDetails([]);
    };

    const handleClearSelectionFarmer = () => {
        setSelectedOptionsFarmer([]);
        setGRNDetails([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'FINANCIALGRN');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setOperationEntityList(newOptionArray);
        }
    }

    async function GetFarmerDetailsByMultipleFactoryID() {
        let model = {
            operationEntityID: selectedOptionsFCC.map(x => x).join(',').toString(),
            supplierType: selectedSupplierType
        }
        var res = await services.GetFarmerDetailsByMultipleFactoryID(model)
        if (res != null) {
            var newOptionArray2 = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray2.push({ label: res[i].givenName, value: res[i].farmerID })
            }
            setFarmerList(newOptionArray2);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(grnDetails);
        var settings = {
            sheetName: 'Financial GRN Report',
            fileName: 'Financial GRN Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Financial GRN Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function handleSearch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data["farmerID"];
            var valueV2 = data["firstName"];
            var valueV3 = data["lastName"];

            setValues({
                ...values,
                farmerID: valueV.toString(),
                farmerName: valueV2 == null ? valueV3.toString() : valueV2.toString()
            });
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'FCC Code': x.fccCode == null ? '-' : x.fccCode,
                    'FCC Name': x.fccName == null ? '-' : x.fccName,
                    'GRN Date': new Date(x.grnDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 }),
                    'Supplier Code - Agrithmics': x.supplierCode == null ? '-' : x.supplierCode,
                    'Supplier Name': x.supplierName == null ? '-' : x.supplierName,
                    'Invoice No': x.invoiceNo == null ? '-' : x.invoiceNo,
                    'GRN Type': x.invoiceNo == null ? '-' : x.grnType ==4 ? "Credit" : "Cash",
                    'Purchase Value': x.purchaceValue == null ? '-' : parseFloat(x.purchaceValue).toFixed(2),
                    'Deduction': (x.deduction == null) || (x.deduction == 0) ? '-' : parseFloat(x.deduction).toFixed(2),
                    'Net Purchase Value': x.netPurchaseValue == null ? '-' : parseFloat(x.netPurchaseValue).toFixed(2)
                }
                res.push(vr);
            });

            var vr = {
                'FCC Code': 'Total',
                'Purchase Value': totalValues.totalPurchaceValue == null ? '-' : parseFloat(totalValues.totalPurchaceValue).toFixed(2),
                'Deduction': (totalValues.totalDeduction == null) || (totalValues.totalDeduction == 0) ? '-' : parseFloat(totalValues.totalDeduction).toFixed(2),
                'Net Purchase Value': totalValues.totalNetPurchaseValue == null ? '-' : parseFloat(totalValues.totalNetPurchaseValue).toFixed(2)
            }
            res.push(vr);

            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptionsFCC.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });

        const farName = [];
        selectedOptionsFarmer.forEach(x => {
            const fildered1 = farmerList.find(y => x === y.value).label
            farName.push(fildered1)
        });

        var grpname
        {
            groupList.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        setSelectedSearchValues({
            ...selectedSearchValues,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.map(x => x).join(','),
            groupName: grpname,
            farmerID: farName.length == 0 ? 'All Farmers' : farName.map(x => x).join(','),
            fromDate: formik.values.fromDate,
            toDate: formik.values.toDate,
        });
    }

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedOptionsFarmer([]);
            setGRNDetails([]);
            setFromDate(new Date());
            setToDate(new Date());
        } else {
            setSelectedOptionsFCC([]);
            setSelectedOptionsFarmer([]);
            setGRNDetails([]);
            setFromDate(new Date());
            setToDate(new Date());
        }
    }

    async function clear() {
        setGRNDetails([]);
    }

    const renderSelectedValueFCC = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderSelectedValueFarmer = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = farmerList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = farmerList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = farmerList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    function calculateTotalQty() {
        const totalPurchaceValue = grnDetails.reduce((accumulator, current) => accumulator + current.purchaceValue, 0);
        const totalDeduction = grnDetails.reduce((accumulator, current) => accumulator + current.deduction, 0);
        const totalNetPurchaseValue = grnDetails.reduce((accumulator, current) => accumulator + current.netPurchaseValue, 0);
        setTotalValues({
            ...totalValues,
            totalPurchaceValue: totalPurchaceValue,
            totalDeduction: totalDeduction,
            totalNetPurchaseValue: totalNetPurchaseValue,
        })

    };

    return (
        <>
            <LoadingComponent />
            <Page title="Financial GRN Report   |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0} >Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptionsFCC}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            renderValue={(selected) => renderSelectedValueFCC(selected)}
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptionsFCC.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptionsFCC.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptionsFCC.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Supplier Type*</InputLabel>
                                        <Select
                                            value={selectedSupplierType}
                                            onChange={(event) => setSelectedSupplierType(event.target.value)}
                                            label="Supplier Type"
                                            
                                        >    
                                            <MenuItem value="0">Registerd Supplier</MenuItem>
                                            <MenuItem value="1">Direct Supplier</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth error={Boolean(touched.farmerID && errors.farmerID)}>
                                        <InputLabel id="multi-select-label">Supplier *</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptionsFarmer}
                                            onChange={handleSelectChangeFarmer}
                                            label="Farmer"
                                            renderValue={(selected) => renderSelectedValueFarmer(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptionsFarmer.length === farmerList.length} color="primary" />
                                                All 
                                            </MenuItem>
                                            {farmerList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptionsFarmer.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.farmerID && errors.farmerID && (
                                            <FormHelperText>{errors.farmerID}</FormHelperText>
                                        )}
                                        {selectedOptionsFarmer.length > 0 && (
                                            <IconButton onClick={handleClearSelectionFarmer} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}

                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}                                             {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>GRN Type</InputLabel>
                                        <Select
                                            value={selectedInvoiceType}
                                            onChange={(event) => setSelectedInvoiceType(event.target.value)}
                                            label="Invoice Type"
                                            disabled={selectedSupplierType === "1"}
                                        >
                                            <MenuItem value="0">All</MenuItem>
                                            <MenuItem value="1">Credit</MenuItem>
                                            <MenuItem value="2">Cash</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button type="button" variant="outlined" color="error"
                                            onClick={() => clearAll()}
                                        >
                                            Clear
                                        </Button>
                                        <Button type="submit" color="secondary" variant="outlined"
                                        >
                                            Search
                                        </Button>
                                    </Stack>
                                </Stack>
                                <br />
                                <>
                                    {grnDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table
                                                                className={classes.table}
                                                                aria-labelledby="tableTitle"
                                                                aria-label="enhanced table"
                                                            >
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="left">FCC Code</TableCell>
                                                                        <TableCell align="left">FCC Name</TableCell>
                                                                        <TableCell align="left">GRN Date</TableCell>  
                                                                        <TableCell align="left">Supplier Code - Agrithmics</TableCell>
                                                                        <TableCell align="left">Supplier Name</TableCell>
                                                                        <TableCell align="left">Invoice No</TableCell>
                                                                        <TableCell align="left">GRN Type</TableCell>
                                                                        <TableCell align="right">Purchase Value</TableCell>
                                                                        <TableCell align="right">Deduction</TableCell>
                                                                        <TableCell align="right">Net Purchase Value</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {stableSort(grnDetails, getComparator(order, orderBy))
                                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((row, index) => {
                                                                            const labelId = `enhanced-table-checkbox-${index}`;

                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell align="left">{row.fccCode}</TableCell>
                                                                                    <TableCell align="left">{row.fccName == null ? '-' : row.fccName}</TableCell>
                                                                                    <TableCell align="left">{row.grnDate == null ? '-' : new Date(row.grnDate).toLocaleDateString()}</TableCell>
                                                                                    <TableCell align="left">{row.supplierCode == null ? '-' : row.supplierCode}</TableCell>
                                                                                    <TableCell align="left">{row.supplierName == null ? '-' : row.supplierName}</TableCell>
                                                                                    <TableCell align="left">{row.invoiceNo == null ? '-' : row.invoiceNo}</TableCell>
                                                                                    <TableCell align="left">{row.supplierName == null ? '-' : row.grnType ==4 ? "Credit" : "Cash" }</TableCell>
                                                                                    <TableCell align="right">{row.purchaceValue == null ? '-' : parseFloat(row.purchaceValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                    <TableCell align="right">{(row.deduction == null) || (row.deduction == 0) ? '-' : parseFloat(row.deduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                    <TableCell align="right">{row.netPurchaseValue == null ? '-' : parseFloat(row.netPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                </TableBody>
                                                                <TableRow>
                                                                    <TableCell align="center" colSpan={7} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalPurchaceValue == null ? '-' : parseFloat(totalValues.totalPurchaceValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{(totalValues.totalDeduction == null) || (totalValues.totalDeduction == 0) ? '-' : parseFloat(totalValues.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalNetPurchaseValue == null ? '-' : parseFloat(totalValues.totalNetPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                </TableRow>
                                                            </Table>
                                                        </TableContainer>

                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={grnDetails.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    ) : null}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {grnDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Financial GRN Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    grnList={grnDetails}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}